// extracted by mini-css-extract-plugin
module.exports = {"container":"m7jAw","arrow":"_1_nlT","page":"Pz_4Y","active":"_3Uqch"};